import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';
import { User } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-certificate-signature',
  templateUrl: './certificate-signature.component.html',
  styleUrls: ['./certificate-signature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateSignatureComponent {
  @Input() user: User;
  @Input() date: string;
}
